import { Action } from '@ngrx/store';

import { QueryParamsModel } from '../../_base/crud';
import { Allergy } from '../_models/allergy.model';
import { Update } from '@ngrx/entity';

export enum AllergyActionTypes {
  AllergyOnServerCreated = '[Edit Allergy Dialog] Allergy On Server Created',
  AllergyCreated = '[Edit Allergy Dialog] Allergy Created',
  AllergyOnServerUpdated = '[Edit Allergy Dialog] Allergy On Server Updated',
  AllergyUpdated = '[Allergy Dialog] Allergy Updated',
  AllergyOnServerDeleted = '[Allergy List Page]  One Allergy On Server Deleted',
  AllergyPageRequested = '[Allergies List Page] Allergies Page Requested',
  AllergyPageLoaded = '[Allergies API] Contact Allergies Page Loaded',
  AllergyPageToggleLoading = '[Allergy] Allergy Loading',
  ThrowAllergyError = '[Allergy] Throw Allergy Error',
  ClearAllergyErrors = '[Allergy] Clear Contact Errors',
  AllergyActionToggleLoading = '[Allergy] Allergy Action Toggle Loading',
  AllergyDeleted = '[Allergy List Page] Allergy Deleted',
}

export class AllergyPageRequested implements Action {
  readonly type = AllergyActionTypes.AllergyPageRequested;

  constructor(public payload: { page: QueryParamsModel; entityId: number; viewContext }) {}
}

export class AllergyPageLoaded implements Action {
  readonly type = AllergyActionTypes.AllergyPageLoaded;

  constructor(public payload: { allergies: Allergy[]; totalCount: number }) {}
}

export class AllergyOnServerCreated implements Action {
  readonly type = AllergyActionTypes.AllergyOnServerCreated;

  constructor(public payload: { allergy: Allergy; entityId: number }) {}
}

export class AllergyOnServerUpdated implements Action {
  readonly type = AllergyActionTypes.AllergyOnServerUpdated;

  constructor(public payload: { allergy: Allergy; entityId: number }) {}
}

export class AllergyDeleted implements Action {
  readonly type = AllergyActionTypes.AllergyDeleted;
  constructor(public payload: { allergy_id: number }) {}
}

export class AllergyUpdated implements Action {
  readonly type = AllergyActionTypes.AllergyUpdated;

  constructor(
    public payload: {
      allergy: Update<Allergy>;
    },
  ) {}
}

export class ThrowAllergyError implements Action {
  readonly type = AllergyActionTypes.ThrowAllergyError;

  constructor(public payload: { error: any }) {}
}

export class AllergyOnServerDeleted implements Action {
  readonly type = AllergyActionTypes.AllergyOnServerDeleted;

  constructor(public payload: { allergy_id: number }) {}
}

export class AllergyPageToggleLoading implements Action {
  readonly type = AllergyActionTypes.AllergyPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class AllergyActionToggleLoading implements Action {
  readonly type = AllergyActionTypes.AllergyActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class AllergyCreated implements Action {
  readonly type = AllergyActionTypes.AllergyCreated;

  constructor(public payload: { allergy: Allergy }) {}
}

export class ClearAllergyErrors implements Action {
  readonly type = AllergyActionTypes.ClearAllergyErrors;
}

export type AllergyActions =
  | AllergyPageRequested
  | AllergyPageLoaded
  | AllergyOnServerCreated
  | AllergyOnServerUpdated
  | AllergyOnServerDeleted
  | AllergyPageToggleLoading
  | AllergyCreated
  | ClearAllergyErrors
  | ThrowAllergyError
  | AllergyUpdated
  | AllergyDeleted
  | AllergyActionToggleLoading;
